module.exports = __webpack_public_path__ + "img/emoji_11.d507ac29.png";